export default "__VITE_ASSET__77f55297__"